import { render, staticRenderFns } from "./SendEmailModal.vue?vue&type=template&id=37ea79f6&scoped=true&"
import script from "./SendEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailModal.vue?vue&type=style&index=0&id=37ea79f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea79f6",
  null
  
)

export default component.exports